import { injectCpmsBoTransactionReportsRevenueStatisticsApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-transaction-reports-revenue-statistics.service';

import { baseApi } from '@service/base-api.service';

export const cpmsBoTransactionReportsRevenueStatisticsApi =
  injectCpmsBoTransactionReportsRevenueStatisticsApi(baseApi);

export const {
  useCpmsBoGetRevenueByLocationQuery,
  useCpmsBoGetRevenueByThirdPartyEndpointQuery,
  useCpmsBoGetRevenueByChargePointQuery,
  useCpmsBoGetRevenueByConnectorTypeQuery,
  useCpmsBoGetRevenueByTokenTypeQuery,
  useCpmsBoGetRevenueByDayQuery,
  useCpmsBoGetRevenueByMonthQuery,
  useCpmsBoGetRevenueByYearQuery,
  useCpmsBoGetRevenueForecastQuery,
  useCpmsBoGetRevenueQuery,
} = cpmsBoTransactionReportsRevenueStatisticsApi;
